import { canTrack, GTMTrack } from '@utils/dataLayer';
import { galleryState as state } from './galleryState';
import { reloadAds } from '@utils/advertisement';
import { callPVMarfeel } from '@utils/marfeel';

let isHandlingArrow = false;

export const handleCarouselArrows = (e: Event) => {
  if (state.getIsMobile()) {
    isHandlingArrow = false;
    return;
  }

  const arrowButton = e.currentTarget as HTMLElement;
  let arrowDirection = 'previous';
  if (
    (e.type === 'click' && (arrowButton as HTMLButtonElement).dataset.glideDir === '>') ||
    (e.type === 'keyup' && (e as KeyboardEvent).key === 'ArrowRight')
  ) {
    arrowDirection = 'next';
  }

  if (canTrack()) {
    GTMTrack(`gallery_${arrowDirection}`, {
      gallery: {
        // Pravděpodobně kvůli pořadí navěšení eventů se keyboard event posílá ještě před aktualizací stavu počítadla
        // Těžko odladitelné kvůli navěšení přes knihovnu (Glide.js), zatím hotfixuju tímto, protože u keyboard eventu si +-1 počítáním můžeme být jisti
        position:
          e.type === 'keyup'
            ? (e as KeyboardEvent).key === 'ArrowRight'
              ? state.getActiveItem() + 1
              : state.getActiveItem() - 1
            : state.getActiveItem(),
      },
    });
  }

  if (isHandlingArrow) return;
  isHandlingArrow = true;

  if (canTrack()) {
    reloadAds();
    callPVMarfeel();
  }

  setTimeout(() => {
    isHandlingArrow = false;
  }, 400);
};

export const galleryClose = () => {
  const closeElements = document.querySelectorAll('[data-gallery-close]');
  closeElements.forEach((closeElement) => {
    closeElement.addEventListener('click', () => {
      GTMTrack('gallery_close');
    });
  });

  return () => {
    closeElements.forEach((closeElement) => {
      closeElement.removeEventListener('click', () => {
        GTMTrack('gallery_close');
      });
    });
  };
};

export const galleryGTMTracking = () => {
  // Máme didomi souhlas?
  if (!canTrack()) return;

  const urlParams = new URLSearchParams(window.location.search);
  const galleryType = urlParams.has('backUrl') ? 'miniGallery' : 'smallGallery';

  // Otevření galerie
  GTMTrack('gallery_open', {
    gallery: {
      source: galleryType,
    },
  });

  // Zavření galerie
  galleryClose();
};
